import React, { useEffect, useRef, useState } from 'react';
import { jarallax, jarallaxElement } from "jarallax";
import axiosInstance from '../axiosConfig';
import { toast } from 'react-toastify';
import ReCAPTCHA from "react-google-recaptcha";
import 'jarallax/dist/jarallax.css';

const ContactForm = () => {
    jarallaxElement();

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, []);

    const recaptchaRef = useRef(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: null }); // Clear the error for the specific field on change
    };

    const handleCaptchaChange = (token) => {
        setFormData({ ...formData, captchaToken: token });
        setErrors({ ...errors, captchaToken: null }); // Clear CAPTCHA error if any
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.captchaToken) {
            setErrors({ ...errors, captchaToken: 'Please complete the CAPTCHA.' });
            return;
        }
        setIsSubmitting(true);
        setErrors({}); // Clear all errors before making the request
        try {
            const response = await axiosInstance.post('contactus', formData);  
            if (response.data.success) {
                toast.success(response.data.message || 'Message sent successfully!');
                setFormData({ name: '', email: '', phone: '', message: '' });
                recaptchaRef.current.reset();
            } else {
                toast.error(response.data.message || 'An error occurred.');
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                toast.error(error.response?.data?.message || 'An error occurred. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };
    

    return (
        <section className="no-top jarallax">
            <div className="de-gradient-edge-top"></div>
            <img src="assets/images/background/7.jpg" className="jarallax-img" alt="" />
            <div className="container position-relative z1000">
                <div className="row gx-5">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="d-sch-table">
                            <h2 className="wow fadeIn text-center">Message Us</h2>
                            <div className="de-separator"></div>
                            <p className="lead text-center">
                                If you got any questions, please do not hesitate to send us a message.
                            </p>
                            <form id="contact_form" className="form-border position-relative z1000" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-12 mb10">
                                        <div className="field-set">
                                            <input
                                                type="text"
                                                name="name"
                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                placeholder="Your Name"
                                                value={formData.name}
                                                onChange={handleChange}
                                            />
                                            {errors.name && (
                                                <div className="invalid-feedback">
                                                    {errors.name[0]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mb10">
                                        <div className="field-set">
                                            <input
                                                type="email"
                                                name="email"
                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                placeholder="Your Email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && (
                                                <div className="invalid-feedback">
                                                    {errors.email[0]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mb10">
                                        <div className="field-set">
                                            <input
                                                type="text"
                                                name="phone"
                                                className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                                placeholder="Your Phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                            />
                                            {errors.phone && (
                                                <div className="invalid-feedback">
                                                    {errors.phone[0]}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="field-set mb20">
                                    <textarea
                                        name="message"
                                        className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                        placeholder="Your Message"
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                    {errors.message && (
                                        <div className="invalid-feedback">
                                            {errors.message[0]}
                                        </div>
                                    )}
                                </div>
                                <div className="mb20">
                                    <ReCAPTCHA
                                        sitekey="6Lc2WrEqAAAAAKr1qfvZAimn-b0LAzNabkkT4vIO" 
                                        onChange={handleCaptchaChange}
                                        ref={recaptchaRef}
                                    />
                                    {errors.captchaToken && (
                                        <div className="text-danger">
                                            {errors.captchaToken}
                                        </div>
                                    )}
                                </div>
                                <div className="text-center">
                                    <div className="mt20">
                                        <button
                                            type="submit"
                                            className="btn-main"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? 'Sending...' : 'Send Message'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div className="d-deco"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="de-gradient-edge-bottom"></div>
        </section>
    );
};

export default ContactForm;
